/* Wishlist — localStorage with handles + wishlist page rendering */
(function () {
  'use strict';
  const KEY = 'shanium_wishlist';
  const WISHLIST_PATH = '/pages/wishlist';
  const money = (cents) => (Number(cents) / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR',
  });

  const normalize = (list) => {
    if (!Array.isArray(list)) return [];
    return list
      .map((item) => {
        if (typeof item === 'string' || typeof item === 'number') {
          const value = String(item);
          if (/^\d+$/.test(value)) return { id: value, handle: '', variantId: '' };
          return { handle: value, id: value, variantId: '' };
        }
        if (item && typeof item === 'object') {
          return {
            id: item.id != null ? String(item.id) : '',
            handle: item.handle || '',
            variantId: item.variantId != null ? String(item.variantId) : '',
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  const get = () => normalize(JSON.parse(localStorage.getItem(KEY) || '[]'));
  const set = (list) => localStorage.setItem(KEY, JSON.stringify(normalize(list)));

  const isWishlistUrl = () => {
    const path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    return path === '/wishlist' || path.endsWith('/pages/wishlist') || path.includes('/wishlist');
  };

  const productsUrl = () =>
    (window.theme && window.theme.routes && window.theme.routes.catalog_collection_url) ||
    '/collections/laddos-and-burfi';

  const updateCount = () => {
    const list = get();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  };

  const isSaved = (btn, list) => {
    const id = String(btn.getAttribute('data-wishlist-toggle') || '');
    const handle = btn.getAttribute('data-wishlist-handle') || '';
    return list.some((item) => (id && item.id === id) || (handle && item.handle === handle));
  };

  const syncButtons = () => {
    const list = get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', isSaved(btn, list) ? 'true' : 'false');
    });
  };

  const removeItem = (id, handle) => {
    const next = get().filter((item) => {
      if (id && item.id === String(id)) return false;
      if (handle && item.handle === handle) return false;
      return true;
    });
    set(next);
    updateCount();
    syncButtons();
    window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: next, id, handle } }));
    return next;
  };

  const fetchProduct = async (item, catalog) => {
    if (item.handle) {
      try {
        const res = await fetch(`/products/${item.handle}.js`);
        if (res.ok) return await res.json();
      } catch (e) { /* continue */ }
    }
    if (item.id && catalog && catalog.length) {
      const match = catalog.find((p) => String(p.id) === String(item.id));
      if (match && match.handle) {
        try {
          const res = await fetch(`/products/${match.handle}.js`);
          if (res.ok) return await res.json();
        } catch (e) { /* continue */ }
      }
    }
    return null;
  };

  const loadCatalogIndex = async () => {
    try {
      const res = await fetch('/collections/laddos-and-burfi/products.json?limit=250');
      if (!res.ok) return [];
      const data = await res.json();
      return data.products || [];
    } catch (e) {
      return [];
    }
  };

  const checkoutVariant = async (variantId, quantity = 1) => {
    if (!variantId) return;
    const cartAdd = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    const res = await fetch(`${cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity }),
    });
    if (!res.ok) throw new Error('Unable to add to cart');
    window.location.href = '/checkout';
  };

  const mountWishlistMarkup = () => {
    if (document.querySelector('[data-wishlist-page]')) return true;
    const main = document.getElementById('MainContent');
    if (!main) return false;
    main.innerHTML = `
      <section class="section wishlist-page" data-wishlist-page>
        <div class="page-width">
          <div class="wishlist-page__intro">
            <p class="eyebrow">Kept for later</p>
            <h1 class="section-title" style="margin:0">Your wishlist</h1>
            <p class="wishlist-page__sub">Items you've saved from across the atelier.</p>
          </div>
          <div class="wishlist-page__toolbar" data-wishlist-toolbar hidden>
            <p class="wishlist-page__count" data-wishlist-page-count></p>
            <button type="button" class="btn btn--primary" data-wishlist-checkout-all>Checkout all</button>
          </div>
          <div id="wishlist-empty" class="wishlist-page__empty" hidden>
            <p>Your wishlist is empty. Explore our collections to save pieces for later.</p>
            <a href="${productsUrl()}" class="btn btn--primary">Explore products</a>
          </div>
          <div class="product-grid wishlist-page__grid" id="wishlist-grid" data-wishlist-grid></div>
        </div>
      </section>
    `;
    document.title = `Your wishlist — ${document.title.replace(/^.*?—\s*/, '').trim() || 'Shanium Yum'}`;
    return true;
  };

  const hideEmptyTips = () => {
    document.querySelectorAll('[data-wishlist-empty-tip]').forEach((tip) => {
      tip.hidden = true;
    });
  };

  const showEmptyTip = (nav) => {
    hideEmptyTips();
    let tip = nav.querySelector('[data-wishlist-empty-tip]');
    if (!tip) {
      tip = document.createElement('span');
      tip.className = 'wishlist-empty-tip';
      tip.setAttribute('data-wishlist-empty-tip', '');
      tip.setAttribute('role', 'status');
      tip.textContent = 'Your list is empty. Please explore our collection.';
      nav.appendChild(tip);
    }
    tip.hidden = false;
    window.clearTimeout(showEmptyTip._timer);
    showEmptyTip._timer = window.setTimeout(() => {
      tip.hidden = true;
    }, 3200);
    announce('Your list is empty. Please explore our collection.');
  };

  const renderPage = async () => {
    if (isWishlistUrl()) mountWishlistMarkup();

    const root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('#wishlist-empty');
    const toolbar = root.querySelector('[data-wishlist-toolbar]');
    const countEl = root.querySelector('[data-wishlist-page-count]');
    const list = get();

    if (!list.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (toolbar) toolbar.hidden = true;
      return;
    }

    const needsCatalog = list.some((item) => !item.handle && item.id);
    const catalog = needsCatalog ? await loadCatalogIndex() : [];

    const products = await Promise.all(list.map(async (item) => {
      const product = await fetchProduct(item, catalog);
      if (!product) return null;
      const variant =
        (item.variantId && product.variants.find((v) => String(v.id) === String(item.variantId))) ||
        product.variants.find((v) => v.available) ||
        product.variants[0];
      return { item, product, variant };
    }));

    const valid = products.filter(Boolean);
    if (!valid.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (toolbar) toolbar.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    if (toolbar) toolbar.hidden = false;
    if (countEl) countEl.textContent = `${valid.length} saved ${valid.length === 1 ? 'piece' : 'pieces'}`;

    grid.innerHTML = valid.map(({ item, product, variant }) => {
      const image = product.featured_image || (product.images && product.images[0]) || '';
      const available = !!(variant && variant.available);
      const variantId = variant ? variant.id : '';
      return `
        <article class="product-card product-card--boxed product-card--purchase wishlist-card" data-wishlist-card data-id="${item.id || ''}" data-handle="${product.handle}" data-variant-id="${variantId}">
          <div class="product-card__box">
            <div class="product-card__media">
              <a href="${product.url}">
                ${image ? `<img src="${image}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy" width="600" height="750">` : '<div class="category-tile__placeholder"></div>'}
              </a>
            </div>
            <div class="product-card__body">
              <h3 class="product-card__title"><a href="${product.url}">${product.title}</a></h3>
              <p class="product-card__price">${money(variant ? variant.price : product.price)}</p>
              ${variant && variant.title && variant.title !== 'Default Title' ? `<p class="wishlist-card__variant">${variant.title}</p>` : ''}
              <div class="wishlist-card__actions">
                <button type="button" class="btn btn--primary" data-wishlist-checkout ${available ? '' : 'disabled'}>
                  ${available ? 'Checkout' : 'Sold out'}
                </button>
                <button type="button" class="btn btn--secondary" data-wishlist-remove>Remove</button>
              </div>
            </div>
          </div>
        </article>
      `;
    }).join('');
  };

  document.addEventListener('click', async (e) => {
    const nav = e.target.closest('[data-wishlist-nav]');
    if (nav) {
      if (!get().length) {
        e.preventDefault();
        e.stopPropagation();
        showEmptyTip(nav);
        return;
      }
      hideEmptyTips();
      return;
    }

    if (!e.target.closest('[data-wishlist-empty-tip]')) {
      hideEmptyTips();
    }

    const toggle = e.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      const id = String(toggle.getAttribute('data-wishlist-toggle') || '');
      const handle = toggle.getAttribute('data-wishlist-handle') || '';
      const variantId = toggle.getAttribute('data-wishlist-variant') || '';
      let list = get();
      const existingIndex = list.findIndex(
        (item) => (id && item.id === id) || (handle && item.handle === handle)
      );

      if (existingIndex >= 0) {
        list.splice(existingIndex, 1);
        toggle.setAttribute('aria-pressed', 'false');
        announce(window.theme?.strings?.removedFromWishlist || 'Removed from wishlist');
      } else {
        list.push({ id, handle, variantId });
        toggle.setAttribute('aria-pressed', 'true');
        announce(window.theme?.strings?.addedToWishlist || 'Saved to wishlist');
      }

      set(list);
      updateCount();
      window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list, id, handle } }));
      return;
    }

    const removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      const card = removeBtn.closest('[data-wishlist-card]');
      if (!card) return;
      removeItem(card.getAttribute('data-id'), card.getAttribute('data-handle'));
      await renderPage();
      return;
    }

    const checkoutBtn = e.target.closest('[data-wishlist-checkout]');
    if (checkoutBtn && !checkoutBtn.disabled) {
      e.preventDefault();
      const card = checkoutBtn.closest('[data-wishlist-card]');
      if (!card) return;
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Redirecting…';
      try {
        await checkoutVariant(card.getAttribute('data-variant-id'));
      } catch (err) {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'Checkout';
      }
      return;
    }

    const checkoutAll = e.target.closest('[data-wishlist-checkout-all]');
    if (checkoutAll) {
      e.preventDefault();
      const cards = Array.from(document.querySelectorAll('[data-wishlist-card]'));
      const items = cards
        .map((card) => ({
          id: Number(card.getAttribute('data-variant-id')),
          quantity: 1,
        }))
        .filter((item) => item.id);
      if (!items.length) return;
      checkoutAll.disabled = true;
      checkoutAll.textContent = 'Redirecting…';
      try {
        const cartAdd = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
        const res = await fetch(`${cartAdd}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('Unable to add items');
        window.location.href = '/checkout';
      } catch (err) {
        checkoutAll.disabled = false;
        checkoutAll.textContent = 'Checkout all';
      }
    }
  });

  function announce(msg) {
    const live = document.getElementById('LiveRegion');
    if (live) {
      live.textContent = '';
      setTimeout(() => {
        live.textContent = msg;
      }, 30);
    }
  }

  window.addEventListener('wishlist:change', () => {
    if (document.querySelector('[data-wishlist-page]') || isWishlistUrl()) renderPage();
  });

  window.ShaniumWishlist = { get, set, updateCount, syncButtons, normalize, renderPage, removeItem };
  updateCount();
  syncButtons();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderPage, { once: true });
  } else {
    renderPage();
  }
})();
